import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import initialData from "../../../../utilities/initialData/initialData";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import LinieService from "../../../konfiguracja/trasyConfig/linie/LinieService";

export default class SprzedazMiesiecznychLiniaSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rok: new Date().toJSON().substr(0, 4),
            miesiac: null,
            linia: null,
            linie: [],
            status: null,
            statusy: [
                {value: '-1', label: 'do opłaty'},
                {value: '1', label: 'opłacony'},
            ],
        };
        this.onChangeRok = this.onChangeRok.bind(this)
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this)
        this.onChangeLinia = this.onChangeLinia.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }


    componentDidMount() {
        this.pobierzLinie();

        let currentmiesiac = (new Date().toJSON().substr(5, 2))
        if (Boolean(currentmiesiac)) {
            this.setState({
                miesiac: initialData.returnArrayMiesiace().find(m => m.value == parseInt(currentmiesiac))
            })
        }
    }

    pobierzLinie() {
        LinieService.getLinie().then(function (response) {
            this.setState({linie: response.data.content})
        }.bind(this))
    }

    onChangeRok(e) {
        if (Boolean(e)) {
            this.setState({
                rok: e.target.value
            })
            if (e.target.value.length !== 4 || e.target.value > new Date().toJSON().substr(0, 4)) {
                alert('Podano nieprawidłowy rok')
            }
        }

    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e})
    }

    onChangeLinia(e) {
        this.setState({linia: e})
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    onClickSzukaj() {
        if (Boolean(this.state.rok) && Boolean(this.state.miesiac)) {
            let data = {
                "idLi": Boolean(this.state.linia) ? this.state.linia.idLi : null,
                "nazLi": Boolean(this.state.linia) ? this.state.linia.relacja : null,
                "mies": this.state.miesiac.value,
                "miesNazwa": this.state.miesiac.label,
                "rok": this.state.rok,
                "statBil": Boolean(this.state.status) ? this.state.status.value : null,
                "statusNazwa": Boolean(this.state.status) ? this.state.status.label : null,
            }

            this.props.handleClickSzukaj(data)
        } else alert('Rok oraz miesiąc są wymagane aby wyszukać wyniki')
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.idLi}</span> {option.relacja}
        </div>
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={1}>
                            <ControlLabel>
                                Rok <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl defaultValue={new Date().toJSON().substr(0, 4)} type={'number'}
                                         onChange={this.onChangeRok} id={'inputRok'} min={2000}
                                         max={new Date().toJSON().substr(0, 4)}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>
                                Miesiąc <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeMiesiac} value={this.state.miesiac}
                                       options={initialData.returnArrayMiesiace()} clearable={false}/>
                        </Col>
                        <Col xs={3}>
                            <ControlLabel>Linia</ControlLabel>
                            <TopSelect onChange={this.onChangeLinia} value={this.state.linia} options={this.state.linie}
                                       labelKey={'relacja'}
                                       valueKey={'idLi'} valueRenderer={this.formatTrasaSelect}
                                       optionRenderer={this.formatTrasaSelect}/>
                        </Col>
                        <Col xs={1}>
                            <ControlLabel>Status</ControlLabel>
                            <TopSelect onChange={this.onChangeStatus} value={this.state.status}
                                       options={this.state.statusy}/>
                        </Col>
                        <Col xs={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnColor={'primary'}
                                             btnSize={'md'} onClick={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={2} lg={12}>
                            <small><span className={'req'}>*</span>Okres na jaki bilety zostały zakupione</small>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznychLinia/components/SprzedazMiesiecznychLiniaSearchbox.js